import {FETCH_ASSESSMENTS_BY_ID} from "../actions/action_assessments";

export default function(state={}, action){
    switch (action.type){
        case FETCH_ASSESSMENTS_BY_ID:
            return action.payload.data.result
        // no default
    }
    return state;
}